import { IPromotionUiCart, IPromotionUiCartInput } from '../../interfaces'
import { getComboPromotionUiDetails } from './getComboPromotionUiDetails'
import { getComplexDirectPromotionUiDetails } from './getComplexDirectPromotionUiDetails'

export const getComplexPromotionUiDetails: (
  args: IPromotionUiCartInput,
) => IPromotionUiCart | undefined = (args) => {
  const {
    cartProduct: { promotionalQty },
  } = args
  if (promotionalQty) {
    return getComboPromotionUiDetails(args)
  }
  return getComplexDirectPromotionUiDetails(args)
}
